import { ButtonProps } from '@mui/material';
import { ArrowRight } from 'react-feather';
import styled from 'styled-components';
import { Button } from '../StyledComponents';

const StyledBackButton = styled(Button)`
  && {
  width: 80px;
  min-width: 80px;
  height: 36px;
  margin-right: 10px;
  border-radius: 8px;
  padding: 8px 16px 8px 10px;
  gap: 8px;
  background: #F8F9FA !important;
  border: none !important;
  color: #3B82F6;
  text-transform: none;
  box-shadow: none !important;
  transition: none !important;

  &:hover {
    background: #F1F5F9 !important;
    border: none !important;
    box-shadow: 0px 1px 2px rgba(17, 24, 39, 0.08) !important;
    transform: none;
  }

  &:active {
    background: #F8F9FA !important;
    border: none !important;
    box-shadow: none !important;
    transform: none;
  }

  &:focus {
    background: #F8F9FA !important;
    border: none !important;
    box-shadow: none !important;
    transform: none;
    outline: none;
  }

  &:focus-visible {
    background: #F8F9FA !important;
    border: none !important;
    box-shadow: none !important;
    transform: none;
    outline: none;
  }
  }
`;

const BackIcon = styled(ArrowRight)`
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin: 0;
  transform: rotate(180deg);
`;

type BackButtonProps = Omit<ButtonProps, 'variant' | 'color' | 'startIcon' | 'endIcon'> & {
  label?: string;
};

const BackButton = ({label = 'Back', ...props}: BackButtonProps) => {
  return (
    <StyledBackButton variant="outlined" color="primary" disableRipple disableElevation {...props}>
      <BackIcon />
      {label}
    </StyledBackButton>
  );
};

export default BackButton;
